'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var colors = ['#4C7CFD', '#A8B3C3', '#96C7FF', '#D0DDEE', '#2D5EC7'];
var legend = {
    enabled: true,
    itemStyle: {
        font: '15px "TT Commons", Arial, sans-serif',
    },
};

exports.colors = colors;
exports.legend = legend;
